var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup48095514(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 36,
    fill: "#FFFEE6",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3682 28.5601L49.6182 25.8021C49.6151 25.8002 49.6119 25.7985 49.6088 25.7966L49.5807 25.7804L49.5783 25.7812C49.4305 25.705 49.2446 25.6929 49.0186 25.7712C45.2329 27.082 42.5502 27.4415 40.5986 26.5717C40.4202 23.4723 40.0987 17.7826 40.1446 17.8131C40.2076 17.8549 35.4225 15.0733 35.4225 15.0733L35.4223 15.0748C34.7967 14.716 33.6457 15.6883 33.4718 17.127C31.9367 29.8223 29.1133 35.2169 20.2565 42.3771C19.1818 43.2458 18.9929 45.0967 19.688 45.4715L19.6868 45.4726L24.382 48.197L29.4931 45.1514C31.5721 46.628 32.6895 49.9107 33.4717 55.4765C33.5239 55.8481 33.6648 56.0745 33.8526 56.1823L33.8528 56.1842L38.6027 58.9389L37.7014 45.7116L54.3682 28.5601Z",
    fill: "url(#paint0_linear_715_339)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4932 45.1514C31.5722 46.6279 32.6895 49.9107 33.4717 55.4765C33.524 55.8481 33.6648 56.0745 33.8526 56.1823L33.8529 56.1842L38.6028 58.9388L37.7015 45.7116L29.4932 45.1514Z",
    fill: "url(#paint1_linear_715_339)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3682 28.5601L49.6182 25.8022C49.6151 25.8002 49.6119 25.7986 49.6087 25.7967L49.5807 25.7804L49.5782 25.7812C49.4305 25.7051 49.2446 25.693 49.0186 25.7712C45.2329 27.082 42.5502 27.4415 40.5985 26.5717L47.2889 34.2019L54.3682 28.5601Z",
    fill: "url(#paint2_linear_715_339)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.743 28.5124C44.8862 31.5792 42.0628 29.4447 40.5278 18.5219C40.3016 16.9124 38.4222 17.9973 38.196 19.8681C36.661 32.5634 33.8376 37.9581 24.9808 45.1182C23.6757 46.1733 23.6757 48.6791 24.9808 48.2272C33.8376 45.1604 36.661 47.2948 38.196 58.2176C38.4222 59.8272 40.3016 58.7422 40.5278 56.8714C42.0628 44.1761 44.8862 38.7815 53.743 31.6214C55.0481 30.5662 55.0481 28.0605 53.743 28.5124Z",
    fill: "url(#paint3_linear_715_339)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_339",
    x1: 28.9411,
    y1: 51.3843,
    x2: 44.5623,
    y2: 21.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1248,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5044,
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_339",
    x1: 34.048,
    y1: 48.1201,
    x2: 34.048,
    y2: 58.4723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6341,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_339",
    x1: 45.9205,
    y1: 30.2727,
    x2: 48.8489,
    y2: 25.2009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6341,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_339",
    x1: 39.3619,
    y1: 50.4999,
    x2: 26.162,
    y2: 27.6378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48095514);
export default __webpack_public_path__ + "static/media/Group 48095514.090c9e0f9617cf3910df0b0b09a55b60.svg";
export { ForwardRef as ReactComponent };